import React from 'react';
import { Trophy, Table, Users } from 'lucide-react';


// Final Group Stage Standings - AFCON 2025 Morocco (as of January 09, 2026)
const groupsData = [
  {
    name: 'A',
    teams: [
      { id: '6262', name: 'Morocco', played: 3, wins: 3, draws: 0, losses: 0, gf: 8, ga: 1, gd: 7, points: 9 },
      { id: '5815', name: 'Mali', played: 3, wins: 1, draws: 1, losses: 1, gf: 3, ga: 3, gd: 0, points: 4 },
      { id: '230692', name: 'Comoros', played: 3, wins: 1, draws: 0, losses: 2, gf: 3, ga: 6, gd: -3, points: 3 },
      { id: '6277', name: 'Zambia', played: 3, wins: 0, draws: 1, losses: 2, gf: 2, ga: 6, gd: -4, points: 1 },
    ]
  },
  {
    name: 'B',
    teams: [
      { id: '10255', name: 'Egypt', played: 3, wins: 2, draws: 1, losses: 0, gf: 6, ga: 2, gd: 4, points: 7 },
      { id: '6316', name: 'South Africa', played: 3, wins: 2, draws: 0, losses: 1, gf: 5, ga: 3, gd: 2, points: 6 },
      { id: '6712', name: 'Angola', played: 3, wins: 1, draws: 1, losses: 1, gf: 3, ga: 4, gd: -1, points: 4 },
      { id: '6290', name: 'Zimbabwe', played: 3, wins: 0, draws: 0, losses: 3, gf: 1, ga: 6, gd: -5, points: 0 },
    ]
  },
  {
    name: 'C',
    teams: [
      { id: '6346', name: 'Nigeria', played: 3, wins: 3, draws: 0, losses: 0, gf: 9, ga: 2, gd: 7, points: 9 },
      { id: '6719', name: 'Tunisia', played: 3, wins: 2, draws: 0, losses: 1, gf: 5, ga: 3, gd: 2, points: 6 },
      { id: '7941', name: 'Tanzania', played: 3, wins: 0, draws: 1, losses: 2, gf: 2, ga: 6, gd: -4, points: 1 },
      { id: '5890', name: 'Uganda', played: 3, wins: 0, draws: 1, losses: 2, gf: 2, ga: 7, gd: -5, points: 1 },
    ]
  },
  {
    name: 'D',
    teams: [
      { id: '6395', name: 'Senegal', played: 3, wins: 2, draws: 1, losses: 0, gf: 7, ga: 2, gd: 5, points: 7 },
      { id: '6321', name: 'DR Congo', played: 3, wins: 2, draws: 1, losses: 0, gf: 6, ga: 2, gd: 4, points: 7 },
      { id: '5883', name: 'Benin', played: 3, wins: 1, draws: 0, losses: 2, gf: 3, ga: 5, gd: -2, points: 3 },
      { id: '5887', name: 'Botswana', played: 3, wins: 0, draws: 0, losses: 3, gf: 0, ga: 7, gd: -7, points: 0 },
    ]
  },
  {
    name: 'E',
    teams: [
      { id: '6317', name: 'Algeria', played: 3, wins: 2, draws: 1, losses: 0, gf: 7, ga: 2, gd: 5, points: 7 },
      { id: '6323', name: 'Burkina Faso', played: 3, wins: 1, draws: 2, losses: 0, gf: 5, ga: 3, gd: 2, points: 5 },
      { id: '8323', name: 'Equatorial Guinea', played: 3, wins: 1, draws: 0, losses: 2, gf: 3, ga: 6, gd: -3, points: 3 },
      { id: '5805', name: 'Sudan', played: 3, wins: 0, draws: 1, losses: 2, gf: 2, ga: 6, gd: -4, points: 1 },
    ]
  },
  {
    name: 'F',
    teams: [
      { id: '6709', name: 'Ivory Coast', played: 3, wins: 2, draws: 1, losses: 0, gf: 6, ga: 2, gd: 4, points: 7 },
      { id: '6629', name: 'Cameroon', played: 3, wins: 2, draws: 1, losses: 0, gf: 5, ga: 2, gd: 3, points: 7 },
      { id: '5965', name: 'Mozambique', played: 3, wins: 1, draws: 0, losses: 2, gf: 4, ga: 6, gd: -2, points: 3 },
      { id: '5889', name: 'Gabon', played: 3, wins: 0, draws: 0, losses: 3, gf: 2, ga: 7, gd: -5, points: 0 },
    ]
  },
];

const allTeams = groupsData.flatMap(group => group.teams);

const GroupStandings = ({ group }) => {
  return (
    <div className="bg-gray-900/70 backdrop-blur-sm border border-gray-800 rounded-xl overflow-hidden shadow-lg">
      <div className="bg-gradient-to-r from-gray-800 to-gray-900 px-5 py-4 border-b border-gray-700">
        <h3 className="text-xl font-bold text-white flex items-center gap-3">
          <Trophy className="text-emerald-400" size={24} />
          Group {group.name}
        </h3>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-950/50 text-gray-400 text-xs uppercase tracking-wider">
              <th className="text-left py-3 px-4 font-medium">#</th>
              <th className="text-left py-3 px-4 font-medium">Team</th>
              <th className="text-center py-3 px-2 font-medium">P</th>
              <th className="text-center py-3 px-2 font-medium">W</th>
              <th className="text-center py-3 px-2 font-medium">D</th>
              <th className="text-center py-3 px-2 font-medium">L</th>
              <th className="text-center py-3 px-2 font-medium">GF</th>
              <th className="text-center py-3 px-2 font-medium">GA</th>
              <th className="text-center py-3 px-2 font-medium">GD</th>
              <th className="text-center py-3 px-2 font-bold text-white">Pts</th>
            </tr>
          </thead>
          <tbody>
            {group.teams.map((team, idx) => (
              <tr 
                key={team.id} 
                className={`border-b border-gray-800 hover:bg-gray-800/50 transition-colors ${
                  idx === 0 ? 'bg-emerald-950/30' : ''
                }`}
              >
                <td className="py-4 px-4 text-gray-300 font-medium">{idx + 1}</td>
                <td className="py-4 px-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex-shrink-0 rounded-full bg-gray-800 flex items-center justify-center overflow-hidden border border-gray-700">
                      <img 
                        src={`https://images.fotmob.com/image_resources/logo/teamlogo/${team.id}.png`} 
                        alt={team.name}
                        className="w-9 h-9 object-contain"
                        onError={e => e.target.src = 'https://via.placeholder.com/48?text=' + team.name.charAt(0)}
                      />
                    </div>
                    <span className="font-medium text-white">{team.name}</span>
                  </div>
                </td>
                <td className="text-center py-4 px-2 text-gray-300">{team.played}</td>
                <td className="text-center py-4 px-2 text-gray-300">{team.wins}</td>
                <td className="text-center py-4 px-2 text-gray-300">{team.draws}</td>
                <td className="text-center py-4 px-2 text-gray-300">{team.losses}</td>
                <td className="text-center py-4 px-2 text-gray-300">{team.gf}</td>
                <td className="text-center py-4 px-2 text-gray-300">{team.ga}</td>
                <td className="text-center py-4 px-2 text-gray-300 font-medium">{team.gd}</td>
                <td className="text-center py-4 px-2 text-emerald-400 font-bold text-lg">{team.points}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const TeamCard = ({ team }) => (
  <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 hover:border-gray-600 transition-all duration-300 hover:shadow-lg hover:shadow-black/30 group">
    <div className="flex flex-col items-center">
      <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gray-800 flex items-center justify-center mb-4 overflow-hidden border-2 border-gray-700 group-hover:border-emerald-600/50 transition-colors">
        <img
          src={`https://images.fotmob.com/image_resources/logo/teamlogo/${team.id}.png`}
          alt={team.name}
          className="w-5/6 h-5/6 object-contain"
          onError={e => e.target.src = 'https://via.placeholder.com/96?text=' + team.name.charAt(0)}
        />
      </div>
      <h3 className="text-base sm:text-lg font-bold text-white text-center group-hover:text-emerald-400 transition-colors">
        {team.name}
      </h3>
    </div>
  </div>
);

export const TeamsPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-950 via-black to-gray-950 text-white pb-16">
      <div className="container mx-auto px-4 sm:px-6 pt-8 md:pt-12 lg:pt-16">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-emerald-400 to-teal-400 mb-4">
            AFCON 2025 Teams & Groups
          </h1>
          <p className="text-gray-400 text-lg sm:text-xl">
            Group Stage Standings • All 24 Participating Nations
          </p>
        </div>


        {/* Group Standings */}
        <section className="mb-16 md:mb-20">
          <h2 className="text-2xl sm:text-3xl font-bold mb-6 md:mb-8 flex items-center gap-3">
            <Table className="text-emerald-400" />
            Group Standings
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 md:gap-8">
            {groupsData.map(group => (
              <GroupStandings key={group.name} group={group} />
            ))}
          </div>
        </section>


        {/* All Teams Grid */}
        <section>
          <h2 className="text-2xl sm:text-3xl font-bold mb-6 md:mb-8 flex items-center gap-3">
            <Users className="text-emerald-400" />
            All 24 Participating Teams
          </h2>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-6">
            {allTeams.map(team => (
              <TeamCard key={team.id} team={team} />
            ))}
          </div>
        </section>

        <div className="mt-16 text-center">
        </div>
      </div>
    </div>
  );
};